import { Component, Input, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { Demande } from 'src/app/model/demande';
import { Entreprise } from 'src/app/model/entreprise';
import { Context, Cible } from 'src/app/model/context';
import { Creneau, Jours } from 'src/app/model/creneau';

@Component({
  selector: 'app-demande',
  templateUrl: './demande.component.html',
  styleUrls: ['./demande.component.css'],
  viewProviders: [{
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new SkipSelf(), ControlContainer]],
  }]
})
export class DemandeComponent {  
  @Input() demande: Demande;
  @Input() context: Context;

  modeChanged(mode: string) {
    if (mode == 'entreprise') {
      this.demande.entreprise = new Entreprise();
    } else {
      this.demande.entreprise = null;
    }
  }

  toggleTarget(target: Cible) {
    setTimeout(() => {
      if (this.context.monoCible)
        this.context.cibles.forEach(t => t.selected = (t.key !== target.key ? false : !t.selected));    
      else
        this.context.cibles.filter(t => t.key === target.key).find(t => t.selected = !t.selected);    

      // this.demande.planning = [];
      // if (target.selected) {
      //   target.creneaux.forEach(c => this.demande.planning.push(new Creneau(c.jour, c.debut, c.fin, c.debut, c.fin)));
      // }      
      this.computeCreneaux();
    });
  }

  computeCreneaux() {
    let tmp: Creneau[] = [];
    this.context.cibles.filter(t => t.selected).forEach(t => {
      t.creneaux.forEach(c => {
        let current: Creneau = null;
        tmp.filter(cTmp => cTmp.jour == c.jour).find(cTmp => current = cTmp);

        if (current == null) {
          current = new Creneau(c.jour, c.debut, c.fin, c.debut, c.fin);
          tmp.push(current);
        } else {
          if (current.debut > c.debut) {
            current.debut = c.debut
            current.min = c.debut;
          }
          if (current.fin < c.fin) {
            current.fin = c.fin;
            current.max = c.fin;
          }
        }
      });
    });
    this.demande.planning = tmp;
  }

  hasSelectedTarget(): boolean {
    let tmp = false || this.context.cibles.length == 0;
    this.context.cibles.forEach(t => tmp = tmp || t.selected);
    return tmp;
  }

}